"use strict";
function squareImage(itemClass) {
    var items = document.querySelectorAll(itemClass);
    if (items && items.length) {
        items.forEach(function (singleItem) {
            var width = singleItem.offsetWidth;
            singleItem.style.height = width + "px";
        });
    }
}
squareImage(".blog-page .trending-posts .square-image");
window.addEventListener('resize', function () {
    squareImage(".blog-page .trending-posts .square-image");
});
window.addEventListener('scroll', function () {
    squareImage(".blog-page .trending-posts .square-image");
});
